// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DEV-ONLY: layout inspector overlay and panel */

.layout-inspector-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9997;
  pointer-events: none;
}

.layout-inspector-hover-rect {
  position: fixed;
  border: 2px solid rgba(100, 150, 255, 0.8);
  background: rgba(100, 150, 255, 0.08);
  box-sizing: border-box;
}

.layout-inspector-box {
  position: fixed;
  box-sizing: border-box;
}

.layout-inspector-box--margin {
  border: 1px dashed rgba(255, 160, 80, 0.9);
  background: rgba(255, 160, 80, 0.06);
}

.layout-inspector-box--border {
  border: 2px solid rgba(255, 200, 100, 0.7);
  background: transparent;
}

.layout-inspector-box--padding {
  border: 1px dashed rgba(80, 200, 120, 0.8);
  background: rgba(80, 200, 120, 0.06);
}

.layout-inspector-box--content {
  background: rgba(100, 150, 255, 0.12);
  border: 1px solid rgba(100, 150, 255, 0.6);
}

.layout-inspector-panel {
  width: 280px;
  color: #e0ddd8;
  font-size: 11px;
  font-family: system-ui, sans-serif;
}

.layout-inspector-panel__section {
  margin-bottom: 10px;
}

.layout-inspector-panel__row {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
  word-break: break-word;
}

.layout-inspector-panel__label {
  flex: 0 0 72px;
  color: #c9c5bf;
}

.layout-inspector-panel__value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layout-inspector-panel__hint {
  margin: 0 0 10px;
  color: #c9c5bf;
  font-size: 11px;
}

.layout-inspector-panel__actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 8px;
  border-top: 1px solid #4a4541;
}

.layout-inspector-panel__checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.layout-inspector-panel__checkbox input {
  margin: 0;
}

.layout-inspector-panel__btn {
  padding: 6px 10px;
  font-size: 11px;
  cursor: pointer;
  background: #4a4541;
  color: #e0ddd8;
  border: 1px solid #5a5551;
  border-radius: 4px;
}

.layout-inspector-panel__btn:hover {
  background: #5a5551;
}

.layout-inspector-panel__btn--primary {
  background: #3d5a4c;
  border-color: #4a6b5a;
}

.layout-inspector-panel__btn--primary:hover {
  background: #4a6b5a;
}

.layout-inspector-panel__tune {
  border-top: 1px solid #4a4541;
  padding-top: 10px;
}

.layout-inspector-panel__tune-title {
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8eb9b2;
  margin-bottom: 4px;
}

.layout-inspector-panel__tune-hint {
  margin: 0 0 8px;
  font-size: 10px;
  color: #c9c5bf;
}

.layout-inspector-panel__tune-hint--spaced {
  margin-top: 8px;
}

.layout-inspector-panel__tune-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.layout-inspector-panel__tune-row--edited .layout-inspector-panel__tune-input {
  border-color: #8eb9b2;
}

.layout-inspector-panel__tune-original {
  flex: 0 0 36px;
  font-size: 10px;
  color: #c9c5bf;
}

.layout-inspector-panel__tune-input {
  width: 56px;
  padding: 2px 6px;
  font-size: 11px;
  background: #3a3632;
  border: 1px solid #4a4541;
  border-radius: 4px;
  color: #e0ddd8;
}

.layout-inspector-panel__tune-unit {
  flex: 0 0 18px;
  font-size: 10px;
  color: #c9c5bf;
}

.layout-inspector-panel__tune-rem {
  margin-left: 6px;
  font-size: 10px;
  color: #9a958e;
}

.layout-inspector-panel__btn--secondary {
  margin-top: 6px;
  background: #3a3632;
}

.layout-inspector-panel__btn--secondary:hover {
  background: #4a4541;
}

.layout-inspector-panel__media-comp {
  border-top: 1px solid #4a4541;
  padding-top: 10px;
  margin-bottom: 10px;
}

.layout-inspector-panel__media-comp-target {
  margin: 0 0 10px;
  font-size: 10px;
  color: #c9c5bf;
  line-height: 1.4;
}

.layout-inspector-panel__media-comp-target strong {
  color: #e0ddd8;
  font-weight: 600;
}

.layout-inspector-panel__media-comp-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  align-items: end;
}

.layout-inspector-panel__media-comp-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
}

.layout-inspector-panel__media-comp-field--full {
  grid-column: 1 / -1;
}

.layout-inspector-panel__media-comp-field .layout-inspector-panel__label {
  flex: none;
}

.layout-inspector-panel__tune-input--wide {
  width: 100%;
  max-width: 120px;
}

.layout-inspector-panel__smart-pre {
  margin: 6px 0 0;
  padding: 6px 8px;
  font-size: 10px;
  line-height: 1.35;
  white-space: pre-wrap;
  word-break: break-word;
  background: #2e2a26;
  border: 1px solid #4a4541;
  border-radius: 4px;
  color: #c9c5bf;
  max-height: 160px;
  overflow: auto;
}

.layout-inspector-panel__color-section {
  border-top: 1px solid #4a4541;
  padding-top: 10px;
}

.layout-inspector-panel__color-block {
  margin-bottom: 8px;
}

.layout-inspector-panel__color-block--edited .layout-inspector-panel__tune-input--color-value {
  border-color: #8eb9b2;
}

.layout-inspector-panel__color-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
}

.layout-inspector-panel__color-head .layout-inspector-panel__label {
  flex: 0 0 72px;
}

.layout-inspector-panel__color-head .layout-inspector-panel__tune-original {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.layout-inspector-panel__color-tools {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 80px;
}

.layout-inspector-panel__color-swatch {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border: 1px solid #5a5551;
  border-radius: 3px;
  box-sizing: border-box;
}

.layout-inspector-panel__color-input-native {
  flex: 0 0 28px;
  width: 28px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  background: transparent;
}

.layout-inspector-panel__color-input-fallback {
  flex: 0 0 28px;
  font-size: 10px;
  color: #9a958e;
  text-align: center;
}

.layout-inspector-panel__tune-input--color-value {
  flex: 1 1;
  min-width: 0;
  width: auto;
  max-width: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/devtools/LayoutInspector.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* DEV-ONLY: layout inspector overlay and panel */\n\n.layout-inspector-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9997;\n  pointer-events: none;\n}\n\n.layout-inspector-hover-rect {\n  position: fixed;\n  border: 2px solid rgba(100, 150, 255, 0.8);\n  background: rgba(100, 150, 255, 0.08);\n  box-sizing: border-box;\n}\n\n.layout-inspector-box {\n  position: fixed;\n  box-sizing: border-box;\n}\n\n.layout-inspector-box--margin {\n  border: 1px dashed rgba(255, 160, 80, 0.9);\n  background: rgba(255, 160, 80, 0.06);\n}\n\n.layout-inspector-box--border {\n  border: 2px solid rgba(255, 200, 100, 0.7);\n  background: transparent;\n}\n\n.layout-inspector-box--padding {\n  border: 1px dashed rgba(80, 200, 120, 0.8);\n  background: rgba(80, 200, 120, 0.06);\n}\n\n.layout-inspector-box--content {\n  background: rgba(100, 150, 255, 0.12);\n  border: 1px solid rgba(100, 150, 255, 0.6);\n}\n\n.layout-inspector-panel {\n  width: 280px;\n  color: #e0ddd8;\n  font-size: 11px;\n  font-family: system-ui, sans-serif;\n}\n\n.layout-inspector-panel__section {\n  margin-bottom: 10px;\n}\n\n.layout-inspector-panel__row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 4px;\n  word-break: break-word;\n}\n\n.layout-inspector-panel__label {\n  flex: 0 0 72px;\n  color: #c9c5bf;\n}\n\n.layout-inspector-panel__value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.layout-inspector-panel__hint {\n  margin: 0 0 10px;\n  color: #c9c5bf;\n  font-size: 11px;\n}\n\n.layout-inspector-panel__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-top: 8px;\n  border-top: 1px solid #4a4541;\n}\n\n.layout-inspector-panel__checkbox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.layout-inspector-panel__checkbox input {\n  margin: 0;\n}\n\n.layout-inspector-panel__btn {\n  padding: 6px 10px;\n  font-size: 11px;\n  cursor: pointer;\n  background: #4a4541;\n  color: #e0ddd8;\n  border: 1px solid #5a5551;\n  border-radius: 4px;\n}\n\n.layout-inspector-panel__btn:hover {\n  background: #5a5551;\n}\n\n.layout-inspector-panel__btn--primary {\n  background: #3d5a4c;\n  border-color: #4a6b5a;\n}\n\n.layout-inspector-panel__btn--primary:hover {\n  background: #4a6b5a;\n}\n\n.layout-inspector-panel__tune {\n  border-top: 1px solid #4a4541;\n  padding-top: 10px;\n}\n\n.layout-inspector-panel__tune-title {\n  font-weight: 700;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #8eb9b2;\n  margin-bottom: 4px;\n}\n\n.layout-inspector-panel__tune-hint {\n  margin: 0 0 8px;\n  font-size: 10px;\n  color: #c9c5bf;\n}\n\n.layout-inspector-panel__tune-hint--spaced {\n  margin-top: 8px;\n}\n\n.layout-inspector-panel__tune-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.layout-inspector-panel__tune-row--edited .layout-inspector-panel__tune-input {\n  border-color: #8eb9b2;\n}\n\n.layout-inspector-panel__tune-original {\n  flex: 0 0 36px;\n  font-size: 10px;\n  color: #c9c5bf;\n}\n\n.layout-inspector-panel__tune-input {\n  width: 56px;\n  padding: 2px 6px;\n  font-size: 11px;\n  background: #3a3632;\n  border: 1px solid #4a4541;\n  border-radius: 4px;\n  color: #e0ddd8;\n}\n\n.layout-inspector-panel__tune-unit {\n  flex: 0 0 18px;\n  font-size: 10px;\n  color: #c9c5bf;\n}\n\n.layout-inspector-panel__tune-rem {\n  margin-left: 6px;\n  font-size: 10px;\n  color: #9a958e;\n}\n\n.layout-inspector-panel__btn--secondary {\n  margin-top: 6px;\n  background: #3a3632;\n}\n\n.layout-inspector-panel__btn--secondary:hover {\n  background: #4a4541;\n}\n\n.layout-inspector-panel__media-comp {\n  border-top: 1px solid #4a4541;\n  padding-top: 10px;\n  margin-bottom: 10px;\n}\n\n.layout-inspector-panel__media-comp-target {\n  margin: 0 0 10px;\n  font-size: 10px;\n  color: #c9c5bf;\n  line-height: 1.4;\n}\n\n.layout-inspector-panel__media-comp-target strong {\n  color: #e0ddd8;\n  font-weight: 600;\n}\n\n.layout-inspector-panel__media-comp-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  align-items: end;\n}\n\n.layout-inspector-panel__media-comp-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n}\n\n.layout-inspector-panel__media-comp-field--full {\n  grid-column: 1 / -1;\n}\n\n.layout-inspector-panel__media-comp-field .layout-inspector-panel__label {\n  flex: none;\n}\n\n.layout-inspector-panel__tune-input--wide {\n  width: 100%;\n  max-width: 120px;\n}\n\n.layout-inspector-panel__smart-pre {\n  margin: 6px 0 0;\n  padding: 6px 8px;\n  font-size: 10px;\n  line-height: 1.35;\n  white-space: pre-wrap;\n  word-break: break-word;\n  background: #2e2a26;\n  border: 1px solid #4a4541;\n  border-radius: 4px;\n  color: #c9c5bf;\n  max-height: 160px;\n  overflow: auto;\n}\n\n.layout-inspector-panel__color-section {\n  border-top: 1px solid #4a4541;\n  padding-top: 10px;\n}\n\n.layout-inspector-panel__color-block {\n  margin-bottom: 8px;\n}\n\n.layout-inspector-panel__color-block--edited .layout-inspector-panel__tune-input--color-value {\n  border-color: #8eb9b2;\n}\n\n.layout-inspector-panel__color-head {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.layout-inspector-panel__color-head .layout-inspector-panel__label {\n  flex: 0 0 72px;\n}\n\n.layout-inspector-panel__color-head .layout-inspector-panel__tune-original {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.layout-inspector-panel__color-tools {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding-left: 80px;\n}\n\n.layout-inspector-panel__color-swatch {\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  border: 1px solid #5a5551;\n  border-radius: 3px;\n  box-sizing: border-box;\n}\n\n.layout-inspector-panel__color-input-native {\n  flex: 0 0 28px;\n  width: 28px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n  background: transparent;\n}\n\n.layout-inspector-panel__color-input-fallback {\n  flex: 0 0 28px;\n  font-size: 10px;\n  color: #9a958e;\n  text-align: center;\n}\n\n.layout-inspector-panel__tune-input--color-value {\n  flex: 1;\n  min-width: 0;\n  width: auto;\n  max-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
